import { render, staticRenderFns } from "./PreciosModelosV2.vue?vue&type=template&id=22948bd6&scoped=true"
import script from "./PreciosModelosV2.vue?vue&type=script&lang=js"
export * from "./PreciosModelosV2.vue?vue&type=script&lang=js"
import style0 from "./PreciosModelosV2.vue?vue&type=style&index=0&id=22948bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22948bd6",
  null
  
)

export default component.exports